/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface InfluencerCouponDetailView {
  couponId?: number;
  couponName?: string;
  couponType?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  editionCount?: number;
  enabled?: number;
  name?: string;
  personId?: number;
  personalUse?: number;
  subscriptionName?: string;
  subscriptionTypeId?: number;
  subscriptionTypeName?: string;
  value?: number;
}
